import { AfterViewInit, Component, ElementRef, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Subscription, fromEvent } from 'rxjs';
import {debounceTime, distinctUntilChanged, take} from 'rxjs/operators';
import { fuseAnimations } from '@fuse/animations';
import { Marker } from 'app/shared/models/marker';
import { MarkerService } from 'app/shared/services/marker.service';
import { Subject } from 'app/shared/models/subject';
import { DataGridComponent } from 'app/components/data-grid/data-grid.component';

@Component({
  selector: 'select-marker',
  templateUrl: './select-marker.component.html',
  styleUrls: ['./select-marker.component.scss'],
  animations: fuseAnimations,
})
export class SelectMarkerComponent implements OnInit, OnDestroy, AfterViewInit {

  title = 'Markers';
  rows: Marker[];
  columns = [];
  searchTerm: string;
  subject: Subject;
  currentSubjectMarkers: number[] = [];
  selectionHasChanged = false;
  hasLoaded = false;

  keyup$: Subscription;

  @ViewChild('search') filter: ElementRef;
  @ViewChild(DataGridComponent) dataGrid: DataGridComponent;

  constructor(
    public dialogRef: MatDialogRef<SelectMarkerComponent>,
    public dialog: MatDialog,
    private markerService: MarkerService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { 
    this.subject = data.subject;
    this.currentSubjectMarkers = (data.subject && data.subject.subjectMarkers) ? data.subject.subjectMarkers.map((i) => i.markerId) : [];
   }

  ngOnInit() {

    this.markerService.getAllData().pipe(take(1)).subscribe((response) => {
      const markers = response.filter((i) => i.hideRecord !== true);
      this.rows = [...markers];
    });

  }

  ngAfterViewInit(){

    this.keyup$ = fromEvent(this.filter.nativeElement, 'keyup').pipe(
      debounceTime(150), distinctUntilChanged())
      .subscribe(() => {
          this.applyFilter(this.filter.nativeElement.value);
    });

    this.columns = [{name: 'Name', prop: 'name', width: '400'}];
    setTimeout(() => {
      this.dataGrid.instance.selectRows(this.currentSubjectMarkers, false);
      setTimeout(() => {
        this.selectionHasChanged = false;
        this.hasLoaded = true;
      }, 100);
    });
  }

  ngOnDestroy(): void {
    if (this.keyup$){this.keyup$.unsubscribe();}
  }

  applyFilter(value){
    this.dataGrid.instance.searchByText(value);
  }

  selectionChanged(e){
    this.selectionHasChanged = true;
  }

  save(){
    const selectedIds = this.dataGrid.instance.getSelectedRowKeys();
    this.dialogRef.close({ selectedIds });
  }
}
